import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { createRandomSeed } from '../../utils/functions';

const EbayIcon: React.FC<IconProps> = ({ size, style, color }) => {
  const rndSeed = createRandomSeed();
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '20'} height={size ?? '21'} fill="none" viewBox="0 0 38 43" data-testid="ebay-icon">
      <defs>
        <clipPath id={`a${rndSeed}`}>
          <path
            d="M0 11h38v27c0 2.76-2.24 5-5 5H5c-2.76 0-5-2.24-5-5V11Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: `url(#a${rndSeed})`,
        }}
      >
        <path
          d="M28 11h10v32H28z"
          style={{
            fill: color ?? '#86b817',
          }}
        />
        <path
          d="M19 11h9v32h-9z"
          style={{
            fill: color ?? '#f5af02',
          }}
        />
        <path
          d="M10 11h9v32h-9z"
          style={{
            fill: color ?? '#0064d2',
          }}
        />
        <path
          d="M0 11h10v32H0z"
          style={{
            fill: color ?? '#e53238',
          }}
        />
      </g>
      <path
        d="M19 0C12.92 0 8 4.92 8 11h3.5c0-4.14 3.36-7.5 7.5-7.5s7.5 3.36 7.5 7.5H30c0-6.08-4.92-11-11-11Z"
        style={{
          fill: color ?? '#707070',
        }}
      />
    </svg>
  );
};
export default EbayIcon;
